export default __webpack_public_path__ + "static/media/additional_color.6a4d21bb.svg";